import Vue from "vue";
import TasksWidget from "./components/TasksWidget.vue";
import store from './store/index';

Vue.config.productionTip = false;

let TasksWidgets = document.querySelectorAll('widget-tasks');
if (TasksWidgets.length) {
    TasksWidgets.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                let language = this.$el.attributes.getNamedItem('language');
                let labels = this.$el.attributes.getNamedItem('labels');
                let userId = this.$el.attributes.getNamedItem('userId');
                let apiBasePath = this.$el.attributes.getNamedItem('apiBasePath');

                // TODO: remove when SAP is not used anymore
                let sourceSystem = this.$el.attributes.getNamedItem('sourceSystem');

                return h(TasksWidget, {
                    props: {
                        configRaw: {
                            language: language ? language.value : null,
                            apiBasePath: apiBasePath ? apiBasePath.value : null,
                            labels: labels ? JSON.parse(labels.value) : null,
                            userId: userId ? userId.value : null,
                            sourceSystem: sourceSystem ? sourceSystem.value : null
                        }                          
                    }
                });
            }
        });
    });
}
